import React from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

import { Breadcrumb, Breadcrumbs } from "@performyard/py-components";

import { useIsNewNavigation } from "../../../api/hooks/defs/navigation";

import { REVIEW_CYCLES_LIST_HREF, parseReviewsOrigin } from "../../../utils/reviewsBreadcrumbs";

const ViewReviewBreadcrumbs = () => {
	const location = useLocation();
	const isNewNav = useIsNewNavigation();
	const mount = typeof document !== "undefined" ? document.getElementById("view-review-breadcrumbs") : null;

	if (!isNewNav || !mount) return null;

	const reviewName = mount.getAttribute("data-review-name") || "Review";
	const cycleName = mount.getAttribute("data-cycle-name") || "Review Cycle";
	const defaultFrom = mount.getAttribute("data-default-from") || "/";

	const { from, label, kind } = parseReviewsOrigin(location.search);

	let rootItems: Breadcrumb[];
	if (kind === "cycle") {
		rootItems = [
			{ pageId: "breadcrumb-review-cycles", name: "Review Cycles", href: REVIEW_CYCLES_LIST_HREF },
			{ pageId: "breadcrumb-review-cycle", name: cycleName, href: from },
		];
	} else if (label) {
		rootItems = [{ pageId: "breadcrumb-reviews-parent", name: label, href: from }];
	} else {
		rootItems = [{ pageId: "breadcrumb-reviews-parent", name: "Reviews of Me", href: defaultFrom }];
	}

	return createPortal(
		<div style={{ padding: "16px 24px 0" }}>
			<Breadcrumbs
				items={[
					...rootItems,
					{ name: reviewName, href: location.pathname, pageId: "breadcrumb-review-current" },
				]}
			/>
		</div>,
		mount
	);
};

export default ViewReviewBreadcrumbs;
